import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=3fcb6772&scoped=true&"
import script from "./UserAdd.vue?vue&type=script&lang=js&"
export * from "./UserAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserAdd.vue?vue&type=style&index=0&id=3fcb6772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcb6772",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fcb6772')) {
      api.createRecord('3fcb6772', component.options)
    } else {
      api.reload('3fcb6772', component.options)
    }
    module.hot.accept("./UserAdd.vue?vue&type=template&id=3fcb6772&scoped=true&", function () {
      api.rerender('3fcb6772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/User/UserAdd.vue"
export default component.exports